import type { MessagesType } from '@izimi/modules';
import { documentsMessages } from '@izimi/modules';

const messages = {
  ...documentsMessages,
  downloadDocument(fileName: string): MessagesType {
    return {
      errorMessage: {
        message: [
          'messages.documents.downloadDocumentFailed',
          {
            fileName,
          },
        ],
      },
    };
  },
  extendTrashDate(fileName: string): MessagesType {
    return {
      successMessage: {
        message: ['messages.documents.extendTrashDateSuccess', { fileName }],
      },
      errorMessage: {
        message: 'messages.documents.extendTrashDateFailed',
      },
    };
  },
};

export default messages;
